"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The EdelmetallMakes model module.
 * @module model/EdelmetallMakes
 * @version 1.0.44
 */
var EdelmetallMakes = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>EdelmetallMakes</code>.
   * verschiedene möglichkeiten der Ausführung bei Edelmetallen
   * @alias module:model/EdelmetallMakes
   */
  function EdelmetallMakes() {
    _classCallCheck(this, EdelmetallMakes);
    EdelmetallMakes.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(EdelmetallMakes, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>EdelmetallMakes</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EdelmetallMakes} obj Optional instance to populate.
     * @return {module:model/EdelmetallMakes} The populated <code>EdelmetallMakes</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new EdelmetallMakes();
        if (data.hasOwnProperty('coin')) {
          obj['coin'] = _ApiClient.default.convertToType(data['coin'], 'String');
        }
        if (data.hasOwnProperty('ingot')) {
          obj['ingot'] = _ApiClient.default.convertToType(data['ingot'], 'String');
        }
        if (data.hasOwnProperty('casket')) {
          obj['casket'] = _ApiClient.default.convertToType(data['casket'], 'String');
        }
        if (data.hasOwnProperty('accessory')) {
          obj['accessory'] = _ApiClient.default.convertToType(data['accessory'], 'String');
        }
        if (data.hasOwnProperty('additionalProperties')) {
          obj['additionalProperties'] = _ApiClient.default.convertToType(data['additionalProperties'], Object);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EdelmetallMakes</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EdelmetallMakes</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['coin'] && !(typeof data['coin'] === 'string' || data['coin'] instanceof String)) {
        throw new Error("Expected the field `coin` to be a primitive type in the JSON string but got " + data['coin']);
      }
      // ensure the json data is a string
      if (data['ingot'] && !(typeof data['ingot'] === 'string' || data['ingot'] instanceof String)) {
        throw new Error("Expected the field `ingot` to be a primitive type in the JSON string but got " + data['ingot']);
      }
      // ensure the json data is a string
      if (data['casket'] && !(typeof data['casket'] === 'string' || data['casket'] instanceof String)) {
        throw new Error("Expected the field `casket` to be a primitive type in the JSON string but got " + data['casket']);
      }
      // ensure the json data is a string
      if (data['accessory'] && !(typeof data['accessory'] === 'string' || data['accessory'] instanceof String)) {
        throw new Error("Expected the field `accessory` to be a primitive type in the JSON string but got " + data['accessory']);
      }
      return true;
    }
  }]);
}();
/**
 * Münzen
 * @member {String} coin
 */
EdelmetallMakes.prototype['coin'] = undefined;

/**
 * Barren
 * @member {String} ingot
 */
EdelmetallMakes.prototype['ingot'] = undefined;

/**
 * Kasette
 * @member {String} casket
 */
EdelmetallMakes.prototype['casket'] = undefined;

/**
 * Zubehör
 * @member {String} accessory
 */
EdelmetallMakes.prototype['accessory'] = undefined;

/**
 * @member {Object} additionalProperties
 */
EdelmetallMakes.prototype['additionalProperties'] = undefined;
var _default = exports.default = EdelmetallMakes;